module.exports = __webpack_public_path__ + "img/th.a80d86c2.svg";